import { Image, Text, View } from 'react-native';

const institutionLogoFallbacks = {
  chase: require('../assets/institutions/chase.png'),
  'chase bank': require('../assets/institutions/chase.png'),
  'citibank online': require('../assets/institutions/citibank.png'),
  fidelity: require('../assets/institutions/fidelity.png'),
  'jpmorgan chase': require('../assets/institutions/chase.png'),
  'jpmorgan chase bank': require('../assets/institutions/chase.png'),
} as const;

export function InstitutionLogo({
  logoBase64,
  name,
  size = 32,
}: {
  logoBase64: string | null | undefined;
  name: string;
  size?: number;
}) {
  if (logoBase64) {
    return (
      <Image
        source={{ uri: `data:image/png;base64,${logoBase64}` }}
        style={{ width: size, height: size, borderRadius: size / 4 }}
        resizeMode="contain"
      />
    );
  }

  const fallbackLogo = institutionLogoFallbacks[name.trim().toLowerCase() as keyof typeof institutionLogoFallbacks];
  if (fallbackLogo) {
    return (
      <Image
        source={fallbackLogo}
        style={{ width: size, height: size, borderRadius: size / 4 }}
        resizeMode="contain"
      />
    );
  }

  const initial = (name ?? '?')[0]?.toUpperCase() ?? '?';
  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 4,
        backgroundColor: '#e5e7eb',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Text style={{ fontSize: size * 0.45, fontWeight: '600', color: '#6b7280' }}>
        {initial}
      </Text>
    </View>
  );
}
